import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  {
    wrapper: {
      position: 'relative',
      display: 'flex',
      // padding: '2px',
      flexDirection: 'column',
      gap: '20px',
      overflow: 'visible',
    },
    active: {
      backgroundColor: '#E2E8DD', // TODO get from theme
      border: '1px solid black',
    },
    tabContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    pillContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
  },
  { name: 'DietaryRequirements' },
);

export default useStyles;
